import { createSelector } from "@ngrx/store";
import { selectAgesState } from "../reducers";
import * as fromAges from "../reducers/ages.reducer";

export const selectAgesIsLoading = () =>
  createSelector(selectAgesState(), fromAges.selectIsLoading);

export const selectAllAges = () =>
  createSelector(selectAgesState(), fromAges.selectAll);

export const selectAgesEntities = () =>
  createSelector(selectAgesState(), fromAges.selectEntities);
